<template>
  <v-data-table
    dense
    :headers="headers"
    :items="items"
    :hide-default-footer="true"
    class="elevation-1"
  />
</template>

<script>
  export default {
    props: {
      items: {
        type: [Object],
        default: () => []
      }
    },
    data() {
      return {
        headers: [
          { text: this.$t('shared.cart.name'), value: 'name' },
          { text: this.$t('shared.cart.price'), value: 'cost' },
          { text: this.$t('shared.cart.amount'), value: 'quantity' }
        ]
      };
    }
  };
</script>

<style lang="scss"></style>
